/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import {computed, signal} from '@preact/signals-react';

export const modbusFormSignal = signal({
  shouldValidate : false
});

export const globalChooserSignal = signal({
  shouldConfirm : false
});

export const openGlobalChooserSignal = signal({
  shouldOpen : false
});

export const shouldValidateAccountChange = computed(() => (
  globalChooserSignal?.value?.shouldConfirm
));

export const shouldValidateAccountOpen = computed(() => (
  openGlobalChooserSignal?.value?.shouldOpen
));
